import type {RouteRecordRaw} from 'vue-router';

import {ERoleSystem} from '@/api/enums/role';

import {EAntIconUrl} from '@/assets/ant/icon/enums';

import {ESettingsFrontType} from '@/config/enums';

export const adminPageRoutes: Array<RouteRecordRaw> = [
  {
    path: 'users',
    name: 'AdminUsersPage',
    meta: {
      menu: {
        name: 'Пользователи',
        icon: EAntIconUrl.USER_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminUsersPage.vue'),
  },
  {
    path: 'roles',
    name: 'AdminRolesPage',
    meta: {
      menu: {
        name: 'Роли',
        icon: EAntIconUrl.USER_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminRolesPage.vue'),
  },
  {
    path: 'resources',
    name: 'AdminResourcesPage',
    meta: {
      menu: {
        name: 'Ресурсы',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminResourcesPage.vue'),
  },
  {
    path: 'layers',
    name: 'AdminLayersPage',
    meta: {
      menu: {
        name: 'Слои',
        icon: EAntIconUrl.BARS_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminLayersPage.vue'),
  },
  {
    path: 'rules',
    name: 'AdminRulesPage',
    meta: {
      menu: {
        name: 'Правила',
        icon: EAntIconUrl.LOCK_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminRulesPage.vue'),
  },
  {
    path: 'priority-config',
    name: 'AdminPriorityConfigPage',
    meta: {
      menu: {
        name: 'Приоритет угроз',
        icon: EAntIconUrl.AIM_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminPriorityConfigPage.vue'),
  },
  {
    path: 'diagnostics',
    name: 'AdminDiagnosticsPage',
    meta: {
      menu: {
        name: 'Диагностика',
        icon: EAntIconUrl.HEAT_MAP_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminDiagnosticsPage.vue'),
  },
  {
    path: 'app-origins',
    name: 'AdminAppOriginsPage',
    meta: {
      menu: {
        name: 'Приложения',
        icon: EAntIconUrl.APPSTORE_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminAppOriginsPage.vue'),
  },
  {
    path: 'tools',
    name: 'AdminToolsPage',
    meta: {
      menu: {
        name: 'Инструменты',
        icon: EAntIconUrl.EDIT_OUTLINED,
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminToolsPage.vue'),
  },
  {
    path: 'models',
    name: 'AdminModelsPage',
    meta: {
      menu: {
        name: 'Модели',
        icon: EAntIconUrl.SHOP_OUTLINED,
        group: {
          name: 'Оборудование',
          icon: EAntIconUrl.DESKTOP_OUTLINED,
        },
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminModelsPage.vue'),
  },
  {
    path: 'devices',
    name: 'AdminDevicesPage',
    meta: {
      menu: {
        name: 'Оборудование',
        icon: EAntIconUrl.DESKTOP_OUTLINED,
        group: {
          name: 'Оборудование',
          icon: EAntIconUrl.DESKTOP_OUTLINED,
        },
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminDevicesPage.vue'),
  },
  {
    path: 'commands',
    name: 'AdminCommandsPage',
    meta: {
      menu: {
        name: 'Команды',
        icon: EAntIconUrl.CODE_OUTLINED,
        group: {
          name: 'Оборудование',
          icon: EAntIconUrl.DESKTOP_OUTLINED,
        },
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminCommandsPage.vue'),
  },
  {
    path: 'command-executes',
    name: 'AdminCommandExecutesPage',
    meta: {
      menu: {
        name: 'Выполняемые команды',
        icon: EAntIconUrl.SYNC_OUTLINED,
        group: {
          name: 'Оборудование',
          icon: EAntIconUrl.DESKTOP_OUTLINED,
        },
      },
      access_mode: [ESettingsFrontType.ADMIN],
      access_roles: [ERoleSystem.ADMIN],
    },
    component: () => import('@/app/admin/pages/AdminCommandExecutesPage.vue'),
  },
];
